import { inr, monthLabel, FEE_LABELS } from "./api";

export const ALLOC_LABELS = { ...FEE_LABELS, group: "Coaching", previous_dues: "Other Charges" };

export const paymentTotal = (p) => (p.allocated
  ? p.amount_received || 0
  : (p.group || 0) + (p.transport || 0) + (p.pt || 0) + (p.previous_dues || 0) + (p.registration || 0) + (p.adjustment || 0));

export const allocationText = (p) => {
  const parts = (p.allocations || []).map((a) => `${ALLOC_LABELS[a.category]} ${monthLabel(a.month)} ${inr(a.amount)}`);
  if (p.credit_used) parts.push(`From credit ${inr(p.credit_used)}`);
  if (p.excess_credit) parts.push(`Kept as credit ${inr(p.excess_credit)}`);
  return parts.join(" · ") || "—";
};
